
import "./ProductRecyclerview.css";


const BrandRecyclerview = ({ items, onItemClick }) => {
  return (
    <div className="horizontal-recyclerview">
      {items.map((item, index) => (
        <div
          key={index}
          className="recyclerview-item"
          onClick={() => onItemClick?.(item)}
        >
          <img src={`${item.image}`} alt={item.name} />

          <h5
            style={{
              fontSize: "13px",
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            {item.name}
          </h5>
        </div>
      ))}
    </div>
  );
};

export default BrandRecyclerview;
